import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { rem } from 'polished';
import { FlexRow } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TableWrapper } from '../General/TableWrapper';
import { SecondTableTh } from '../General/Table';
import { DsiProductCartTableRow as ProductCartTableRow } from './ProductCartTableRow';
import { DsiOrderDetailItemMobile as OrderDetailItemMobile } from '../MyAccount/OrderDetail/OrderDetailItemMobile';
import { ProductCartMobileTab } from './ProductCartMobileTab';
import { prop } from '../../../utilities';
import { DsiProductCartTableSaleRow } from './ProductCartTableSaleRow';
import { Coupon } from './Summary/Coupon';

interface Props {
  products: any;
  addToCart: any;
  removeFromCart: any;
  onCountRemoveFromCart?: any;
  updateCart: any;
  isB2B?: boolean;
  setItemFree?: any;
  conditionTextMapping?: any;
  isCorporate: boolean;

  couponCode: string;
  onCouponCodeChanged: any; 
  addCoupon: any;
  removeCoupon: any;
  couponError?: string | null;
  isFetching: boolean;
  data: any;
}

function ProductCartTableList(props: Props) {
  const {
    products,
    addToCart,
    removeFromCart,
    isB2B,
    updateCart,
    setItemFree,
    conditionTextMapping,
    onCountRemoveFromCart,
    isCorporate,
    couponCode,
    onCouponCodeChanged,
    addCoupon,
    removeCoupon,
    couponError,
    isFetching,
    data
  } = props;

  const columns = [
    { name: '', padding:"0" },
    { name: __('Produkt'), width: '100%' },
    isB2B
      ? { name: __('Cena bez DPH'), minWidth: rem(120) }
      : { name: __('Cena s DPH'), minWidth: rem(120) },
    { name: __('Množstvo'), minWidth: rem(160) },
    isB2B ? { name: __('Spolu bez DPH') } : { name: __('Spolu s DPH') },
    { name: '', minWidth: rem(56) },
  ];

  const headers =
    columns &&
    columns.map((item: any) => (
      <SecondTableTh
        width={item.width}
        minWidth={item.minWidth}
        padding={item.padding}
        align={item.align || 'left'}
        key={item.name}
      >
        {item.name}
      </SecondTableTh>
    ));

  const itemsRows = [
    products &&
      products.map((item, i) =>
        !item.is_meta_item ? (
          <ProductCartTableRow
            key={item.good.good_id}
            item={item}
            addToCart={addToCart}
            removeFromCart={removeFromCart}
            onCountRemoveFromCart={onCountRemoveFromCart}
            isB2B={isB2B}
            updateCart={updateCart}
            setItemFree={setItemFree}
            previousItem={products[i - 1] ? products[i - 1] : null}
            conditionTextMapping={conditionTextMapping}
            isCorporate={isCorporate}
          />
        ) : null,
      ),
  ];

  const mobileProductsComponent =
    products &&
    products.map((item: any, i) =>
      !item.is_meta_item ? (
        <ProductCartMobileTab
          key={item.good.good_id}
          item={item}
          addToCart={addToCart}
          removeFromCart={removeFromCart}
          onCountRemoveFromCart={onCountRemoveFromCart}
          isB2B={isB2B}
          updateCart={updateCart}
          setItemFree={setItemFree}
          previousItem={products[i - 1] ? products[i - 1] : null}
          conditionTextMapping={conditionTextMapping}
          isCorporate={isCorporate}
        />
      ) : null,
    );

  return (
    <Wrapper>
      <DesktopListProductsWrapper>
        <TableWrapper
          tableHasBorder={false}
          tableHasBoxShadow={false}
          noItemsText={__('Nenašli sa žiadne dopytované produkty')}
          headers={headers}
          rows={itemsRows}
        />
      </DesktopListProductsWrapper>
      <MobileListProductsWrapper>
        {mobileProductsComponent}
      </MobileListProductsWrapper>
      <MobileCouponWrapper>
          <Coupon
              code={couponCode}
              onCodeChanged={onCouponCodeChanged}
              addCode={addCoupon}
              removeCode={removeCoupon}
              activeCoupon={prop(data, 'giftcards.0')}
              isFetching={isFetching}
              couponError={couponError}
              itemsRestrictions={data.items_giftcard_restrictions}
          />
      </MobileCouponWrapper>
    </Wrapper>
  );
}

const animateIn = keyframes`
   0% {
    opacity: 0;
    transform: scale(0.6) translateY(-8px);
  }
  
  100% {
    opacity: 1;
  }
`;

const Wrapper = styled(FlexRow)`
  flex-flow: row wrap;
  animation: ${animateIn} 0.2s ease;
  margin-top: ${rem(32)};
  width: 100%;

  ${({ theme }) => theme.mediab.m810`
      margin-bottom: ${({ visible }) => (visible ? rem(32) : 0)};
      margin-right: -${rem(16)};
  `};
`;

const DesktopListProductsWrapper = styled.div`
  display: block;
  width: 100%;

  ${({ theme }) => theme.mediab.m810`
    display: none;
  `}
`;

const MobileListProductsWrapper = styled.div`
  display: none;
  width: 100%;

  ${({ theme }) => theme.mediab.m810`
      display: flex;
      justify-content: center;
      flex-flow: column;
  `}
`;

const MobileCouponWrapper = styled.div`
  display: none;
  width: 100%;
  margin-top: ${rem(20)};

  ${({ theme }) => theme.mediab.l1150`
      display: flex;
      justify-content: center;
      flex-flow: column;
  `}
`




export { ProductCartTableList as DsiProductCartTableList };
